/**
 * 微信分享卡片的「纯逻辑」层：分享标题怎么取、是不是微信浏览器、SDK 怎么挑。
 *
 * 不在这里 import weixin-js-sdk / api：这层的每一条都要能在 node 里直接测，
 * 带 import 就没法测了（@ 别名、CJS/ESM 混着来）。真正碰 window/接口的活在
 * wechatShareRuntime.js 里，那层只做组装，不放逻辑。
 */

/** 品牌兜底卡片：任何不适合透出页面标题的场景都用它 */
export const SHARE_BRAND = {
	title: '智慧洁净室',
	desc: '设备监控 · 售后服务 · 仓储管理'
}

/**
 * 决定当前页分享出去的标题/描述。
 *
 * 规则刻意保守：
 * - 只有首页允许透出标题（Home.vue 会把它替换成当前应用名，分享卡片直接写
 *   应用名，收件人一眼知道是哪个车间）；
 * - 其余页面（售后/仓库/用户管理……）收件人打开也要登录，透出"内部工作台"
 *   这种标题反而误导，统一用品牌卡片。
 *
 * @param routePath  路由 path
 * @param docTitle   document.title（可能是各页面设过的标题）
 */
export function buildShareMeta(routePath, docTitle) {
	if (routePath === '/') {
		const name = (docTitle || '').trim()
		// "智慧生产车间"是 Home.vue 拿到应用名之前的占位标题，不能拿去当分享标题
		return {
			title: name && name !== '智慧生产车间' ? name : SHARE_BRAND.title,
			desc: SHARE_BRAND.desc
		}
	}
	return { title: SHARE_BRAND.title, desc: SHARE_BRAND.desc }
}

/** 非微信浏览器里一切分享配置都是白做，直接跳过 */
export function isWechatBrowser(ua) {
	const agent = ua !== undefined
		? ua
		: (typeof navigator !== 'undefined' ? navigator.userAgent : '')
	return /micromessenger/i.test(agent)
}

/** 三种来源里挑一个真 SDK（import 的包 / 微信注入的 jWeixin / wx），挑不到就拉倒 */
export function pickWechatSDK(candidates) {
	return (candidates || []).find(item =>
		item && typeof item.config === 'function' && typeof item.ready === 'function'
	) || null
}
